import React from "react";
import Article from "../../components/global/Articles/Article";
import Layout from "../../components/layout/Layout/Layout";
import Header from "../../components/layout/Header/Header";
import BaseWineSearchBar from "../../components/global/SearchBar/BaseWineSearchBar";
import { getArticleFromSlug } from "../../lib/articleRequests";
import { withUserSSR } from "../../utils/withUserSSR";

export default function ArticlePage({
  article,
  slug,
  rawContent,
  contentTruncated,
  imageUrl,
  error,
}) {
  return (
    <Layout>
      <Header></Header>
      <BaseWineSearchBar className="pb-8" hideResults={true} />
      <Article
        article={article}
        slug={slug}
        rawContent={rawContent}
        contentTruncated={contentTruncated}
        imageUrl={imageUrl}
        error={error}
      />
    </Layout>
  );
}

export const getServerSideProps = withUserSSR(async (context) => {
  const { slug } = context.params;
  try {
    // Forward the visitor's session so subscribers get the full article body.
    const { data } = await getArticleFromSlug(slug as string, context.req.headers.cookie || "");
    const article = data.article;
    const rawContent = data.raw_content;
    // The API truncates paywalled bodies to a teaser for non-subscribers.
    const contentTruncated = data.content_truncated === true || article?.content_truncated === true;
    const imageUrl = data.image_url;
    if (article.published === false) {
      return {
        redirect: {
          destination: "/",
          permanent: false,
        },
      };
    }
    return {
      props: {
        article,
        rawContent,
        contentTruncated,
        imageUrl,
        slug,
        error: null,
      },
    };
  } catch (error) {
    if (error?.data?.error === "Article not found") {
      return {
        notFound: true,
      };
    }
    return {
      props: {
        error: `Failed to fetch article data for slug ${slug}`,
      },
    };
  }
});
